import Input from '@/components/forms/Input';
import { Translation, useDynamicLocale } from '@/hoslog-intl';
import { useFormContext } from 'react-hook-form';

export const Others = () => {
  const { register } = useFormContext();
  const { t } = useDynamicLocale();
  return (
    <div className="flex gap-5 sm:gap-10 md:gap-15 lg:gap-20">
      <div className="w-[200px] xl:w-[245px] shrink-0">
        <p className="text-base font-semibold  whitespace-nowrap  pl-12">
          <Translation id="storeManagement.premiumStores.manageStoreInformation.fieldTitle.others" />
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <Input
          label="storeManagement.form.sns.label.website"
          {...register('website')}
          placeholder={t('common.form.placeholder.website')}
        />
        <Input
          label="storeManagement.form.sns.label.googleMap"
          {...register('googleMap')}
          forceRequired
          placeholder={t('common.form.placeholder.googleMaps')}
        />
      </div>
    </div>
  );
};
